import React from 'react'
import { COLOR_INTENT } from 'Theme'

type IconProps = { size?: number }

export const SearchIcon: React.FC<IconProps> = ({ size = 21 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.4}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.2-3.2" />
  </svg>
)

export const ShieldIcon: React.FC<IconProps> = ({ size = 21 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.4}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 3 5 6v5c0 4.4 3 7.7 7 9 4-1.3 7-4.6 7-9V6l-7-3Z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
)

export const GrowthIcon: React.FC<IconProps> = ({ size = 21 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.4}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 18 10 12l3.5 3.5L20 9" />
    <path d="M15 9h5v5" />
  </svg>
)

export const UsersIcon: React.FC<IconProps> = ({ size = 21 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.4}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="9" cy="8" r="3" />
    <path d="M3.5 20a5.5 5.5 0 0 1 11 0" />
    <path d="M16 5.5a3 3 0 0 1 0 5.8M20.5 20a5.5 5.5 0 0 0-3.5-5.1" />
  </svg>
)

export const TagIcon: React.FC<IconProps> = ({ size = 21 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.4}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z" />
    <circle cx="7.5" cy="7.5" r="1.2" />
  </svg>
)

export const ChatIcon: React.FC<IconProps> = ({ size = 21 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.4}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 12a8 8 0 0 1-11.7 7.1L3.5 20.5l1.4-5.8A8 8 0 1 1 21 12Z" />
  </svg>
)

export const MegaphoneIcon: React.FC<IconProps> = ({ size = 21 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.4}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 10v4a1 1 0 0 0 1 1h2l5 4V5L7 9H5a1 1 0 0 0-1 1Z" />
    <path d="M16 8.5a4 4 0 0 1 0 7" />
  </svg>
)

export const ChevronDownIcon: React.FC<IconProps> = ({ size = 21 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor">
    <path d="M8.13797 10.0601C8.04967 9.96617 8 9.83837 8 9.70505C8 9.57173 8.04967 9.44393 8.13797 9.35005L8.32454 9.15005C8.4123 9.05239 8.53389 8.99809 8.66037 9.00005H15.3396C15.4661 8.99809 15.5877 9.05239 15.6755 9.15005L15.862 9.35005C15.9503 9.44393 16 9.57173 16 9.70505C16 9.83837 15.9503 9.96617 15.862 10.0601L12.3265 13.8501C12.2419 13.9467 12.1237 14.0016 12 14.0016C11.8763 14.0016 11.7581 13.9467 11.6735 13.8501L8.13797 10.0601Z" />
  </svg>
)

export const CheckCircleIcon: React.FC<IconProps> = ({ size = 21 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none">
    <circle
      cx="12"
      cy="12"
      r="12"
      fill={COLOR_INTENT.WIDGETS.TRADE_PAGE.CTA_BG}
    />
    <path
      d="m5 12 5 5 9-10"
      stroke={COLOR_INTENT.WIDGETS.TRADE_PAGE.CTA_TEXT}
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LockIcon: React.FC<IconProps> = ({ size = 21 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="5" y="11" width="14" height="9" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
)

export const VALUE_PROP_ICONS = {
  search: SearchIcon,
  shield: ShieldIcon,
  growth: GrowthIcon,
  users: UsersIcon,
} as const

export const CATEGORY_ICONS = {
  tag: TagIcon,
  chat: ChatIcon,
  people: UsersIcon,
  mega: MegaphoneIcon,
} as const
